// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"361b1581","570":"ee1a3e0a"}[chunkId] + ".chunk.js";
};